<app-menu-common url="hr"></app-menu-common>

@if (hrService.backendMissing()) {
	<div class="hr-backend-warn">Backend RH non déployé : données indisponibles (voir docs/backend-brief-hr.md).</div>
}

<div class="flexrow hr-header">
	<button mat-icon-button aria-label="Année précédente" (click)="onShiftPeriod(-1)">
		<mat-icon>chevron_left</mat-icon>
	</button>
	@if (period) {
		<span class="period-label" [matTooltip]="leavePeriodLabel(period)">
			Année de congés {{ leavePeriodShortLabel(period) }}
		</span>
	}
	<button mat-icon-button aria-label="Année suivante" (click)="onShiftPeriod(1)">
		<mat-icon>chevron_right</mat-icon>
	</button>
	<button mat-stroked-button class="hr-btn" (click)="onCurrentPeriod()">Année en cours</button>

	@if (window) {
		<span class="campaign-chip" [class.late]="window.late" [class.open]="window.open && !window.late">
			<mat-icon>{{ window.late ? 'priority_high' : (window.open ? 'campaign' : 'schedule') }}</mat-icon>
			&nbsp;{{ window.late ? 'Clôture en retard' : (window.open ? 'Campagne ouverte' : 'Campagne à venir') }}
		</span>
	}

	<span class="spacer"></span>

	@if (isAdmin && rules.closing_enabled) {
		@if (rules.closing_employee_ack) {
			<button mat-stroked-button class="hr-btn" (click)="onPrepareAll()"
				matTooltip="Proposer son solde à chaque salarié — il le valide, vous clôturez ensuite">
				<mat-icon>outgoing_mail</mat-icon>&nbsp;Proposer les soldes
			</button>
			<button mat-stroked-button class="hr-btn" (click)="onCloseAccepted()"
				matTooltip="Arrêter d'un bloc les comptes que les salariés ont validés">
				<mat-icon>done_all</mat-icon>&nbsp;Arrêter les comptes validés
			</button>
		}
	}
</div>

<!-- ─────────── Clôture désactivée : on dit pourquoi et où l'activer ─────────── -->
@if (!rules.closing_enabled) {
	<div class="closing-off">
		<mat-icon>beach_access</mat-icon>
		<div>
			<b>L'établissement n'arrête pas le compte de l'année de congés.</b>
			<p>
				Les soldes continuent d'être calculés, mais rien n'est reporté d'une année sur l'autre :
				chaque période repart de ses seuls droits. Pour activer la campagne, ouvrir
				<a routerLink="/hr/organization">Établissements &amp; services</a>, panneau
				<b>Règles de paie ▸ Congés &amp; jours fériés ▸ L'année de congés</b>.
			</p>
		</div>
	</div>
} @else {

<!-- ─────────── Ce qui reste à faire, en trois chiffres ─────────── -->
<div class="closing-totals">
	<div class="tot main" [class.done]="summary.pending === 0">
		<span class="tot-value">{{ summary.pending }}</span>
		<span class="tot-label">compte{{ summary.pending > 1 ? 's' : '' }} à arrêter</span>
		<span class="tot-sub">sur {{ summary.total }}</span>
	</div>
	<div class="tot">
		<span class="tot-value">{{ daysLabel(summary.balance_days) }}</span>
		<span class="tot-label">en attente d'arbitrage</span>
	</div>
	<div class="tot carried">
		<span class="tot-value">{{ daysLabel(summary.carried_days) }}</span>
		<span class="tot-label">reportés sur l'année suivante</span>
		<span class="tot-sub">{{ summary.closed }} compte(s) arrêté(s)</span>
	</div>
	@if (summary.lost_days > 0) {
		<div class="tot lost">
			<span class="tot-value">{{ daysLabel(summary.lost_days) }}</span>
			<span class="tot-label">perdus</span>
		</div>
	}
</div>

<!-- ─────────── Ce que la campagne demande, en une phrase ─────────── -->
@if (window) {
	<p class="campaign-hint">
		@if (window.late) {
			L'année {{ leavePeriodShortLabel(window.period) }} est close depuis le
			<b>{{ window.period.to.slice(8, 10) }}/{{ window.period.to.slice(5, 7) }}/{{ window.period.to.slice(0, 4) }}</b>
			et les comptes ne sont pas arrêtés. Tant qu'ils ne le sont pas, <b>rien n'est reporté</b> sur
			l'année en cours : les soldes affichés ailleurs ignorent ces jours.
		} @else if (window.open) {
			L'année {{ leavePeriodShortLabel(window.period) }} s'achève le
			<b>{{ window.period.to.slice(8, 10) }}/{{ window.period.to.slice(5, 7) }}/{{ window.period.to.slice(0, 4) }}</b>.
			C'est le moment de dire à chacun ce qu'il lui reste, et ce qu'on en fait — reporté sur
			l'année suivante, perdu, ou payé.
		} @else {
			La campagne s'ouvrira le
			<b>{{ window.opens.slice(8, 10) }}/{{ window.opens.slice(5, 7) }}/{{ window.opens.slice(0, 4) }}</b>,
			{{ rules.closing_notice_days }} jours avant la fin de la période. Les comptes affichés ici sont
			encore provisoires.
		}
	</p>
}

<!-- ─────────── Les comptes ─────────── -->
@if (lines.length === 0) {
	<p class="empty">
		@if (loading) { Chargement… }
		@else if (isAdmin) { Aucun salarié n'a de solde à arbitrer sur cette année. }
		@else { Aucun solde de congés à valider pour vous sur cette année. }
	</p>
} @else {
<table mat-table [dataSource]="lines" class="closing-table">

	<ng-container matColumnDef="employee">
		<th mat-header-cell *matHeaderCellDef>Salarié</th>
		<td mat-cell *matCellDef="let l">
			<span class="emp" [class.me]="l.mine">{{ l.employee }}</span>
			@for (w of l.row.warnings; track w) {
				<mat-icon class="row-warn" [matTooltip]="w">info</mat-icon>
			}
		</td>
	</ng-container>

	<ng-container matColumnDef="carried_in">
		<th mat-header-cell *matHeaderCellDef matTooltip="Reporté de l'année précédente, d'après sa clôture">Report N-2</th>
		<td mat-cell *matCellDef="let l" class="num">
			{{ l.row.carried_in > 0 ? daysLabel(l.row.carried_in) : '—' }}
		</td>
	</ng-container>

	<ng-container matColumnDef="acquired">
		<th mat-header-cell *matHeaderCellDef>Acquis</th>
		<td mat-cell *matCellDef="let l" class="num">
			{{ daysLabel(l.row.acquired_days) }}
			@if (l.row.fractionation_days > 0) {
				<span class="frac" matTooltip="Jours de fractionnement (L3141-23)">+{{ l.row.fractionation_days }}</span>
			}
		</td>
	</ng-container>

	<ng-container matColumnDef="taken">
		<th mat-header-cell *matHeaderCellDef>Pris</th>
		<td mat-cell *matCellDef="let l" class="num">{{ daysLabel(l.row.taken_days) }}</td>
	</ng-container>

	<ng-container matColumnDef="balance">
		<th mat-header-cell *matHeaderCellDef>Solde</th>
		<td mat-cell *matCellDef="let l" class="num balance" [class.negative]="l.row.balance_days < 0">
			{{ daysLabel(l.row.balance_days) }}
		</td>
	</ng-container>

	<ng-container matColumnDef="decision">
		<th mat-header-cell *matHeaderCellDef>Décision</th>
		<td mat-cell *matCellDef="let l" class="decision">{{ decisionLabel(l.row) }}</td>
	</ng-container>

	<ng-container matColumnDef="state">
		<th mat-header-cell *matHeaderCellDef>État</th>
		<td mat-cell *matCellDef="let l">
			<span class="state-chip" [class]="l.row.status" [matTooltip]="statusHint(l)">
				{{ statusLabel(l.row.status) }}
			</span>
		</td>
	</ng-container>

	<ng-container matColumnDef="actions">
		<th mat-header-cell *matHeaderCellDef></th>
		<td mat-cell *matCellDef="let l" class="actions">
			@if (canAck(l)) {
				<button mat-flat-button color="primary" class="ack-btn" (click)="onAck(l)"
					matTooltip="Enregistrer votre accord sur ce solde">
					<mat-icon>how_to_reg</mat-icon>&nbsp;Je valide
				</button>
			}
			@if (canClose(l)) {
				<button mat-icon-button (click)="onClose(l)"
					[matTooltip]="l.row.closing ? 'Corriger cet arrêté' : 'Arrêter le compte'"
					[attr.aria-label]="l.row.closing ? 'Corriger cet arrêté' : 'Arrêter le compte'">
					<mat-icon>{{ l.row.closing ? 'edit' : 'gavel' }}</mat-icon>
				</button>
				@if (l.row.closing) {
					<button mat-icon-button (click)="onReopen(l)" matTooltip="Rouvrir ce compte (l'arrêté est effacé)" aria-label="Rouvrir ce compte">
						<mat-icon>lock_open</mat-icon>
					</button>
				}
			}
		</td>
	</ng-container>

	<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
	<tr mat-row *matRowDef="let row; columns: displayedColumns;"
		[class.closed-row]="row.row.status === 'closed'" [class.my-row]="row.mine"></tr>
</table>
}

<!-- ─────────── Ce que cet écran est, et ce qu'il n'est pas ─────────── -->
<p class="legal">
	<b>Tout ce qui est affiché ici se recalcule</b> depuis les absences : l'acquis, le pris, le solde.
	Seule la <b>décision</b> — reporté, perdu, payé — est enregistrée, avec qui l'a prise et quand.
	C'est ce qui permet de corriger une règle rétroactivement sans réécrire l'histoire d'un accord
	passé. Les congés non pris sont en principe <b>perdus</b> (L3141-12 s.) : le report suppose un
	accord, un usage, ou une impossibilité de les prendre du fait de l'employeur.
</p>

}
